import EsusView from 'components/esus/EsusView'

export default function FichaAtendimentoDomiciliarView() {
  return <EsusView url='/pec/user/cds/atendimentoDomiciliar' />
}
